import React from 'react';

const ScreenTimeCard = ({ screenTime, goalTime, timeRange }) => {
  // Calculate percentage of goal
  const percentage = Math.min(Math.round((screenTime / goalTime) * 100), 100);
  
  // Determine color based on percentage
  let ringColor = 'text-green-500';
  if (percentage > 100) {
    ringColor = 'text-red-500';
  } else if (percentage > 80) {
    ringColor = 'text-yellow-500';
  }
  
  // Format time display
  const formatTime = (time) => {
    const hours = Math.floor(time);
    const minutes = Math.round((time - hours) * 60);
    
    if (hours === 0) {
      return `${minutes}m`;
    } else if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}m`;
    }
  };
  
  return (
    <div className="card flex flex-col items-center justify-center text-center">
      <h3 className="text-lg font-medium text-gray-900">Screen Time</h3>
      <div className="mt-2 relative inline-flex">
        <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center">
          <svg viewBox="0 0 36 36" className="w-20 h-20">
            {/* Background circle */}
            <path
              className="text-gray-200"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeDasharray="100, 100"
            />
            {/* Foreground circle */}
            <path
              className={ringColor}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeDasharray={`${percentage}, 100`}
              strokeLinecap="round"
            />
            <text x="18" y="20.35" className="text-3xl font-medium" textAnchor="middle" fill="currentColor">
              {percentage}%
            </text>
          </svg>
        </div>
      </div>
      <div className="mt-4 text-2xl font-semibold">{formatTime(screenTime)}</div>
      <p className="mt-1 text-sm text-gray-500">
        {percentage > 100 ? 'Over' : 'of'} {formatTime(goalTime)} goal for {timeRange}
      </p>
    </div>
  );
};

export default ScreenTimeCard; 